import gql from "graphql-tag";

const gqlQuery = gql`
  query GraphicSet($graphicSetId: ID, $customerId: ID) {
    graphicset(graphicSetId: $graphicSetId, customerId: $customerId) {
      id
      name
      description
      customerId
      hasEvents
    }
  }
`;

const gqlQueryWithAssets = gql`
  query GraphicSet($graphicSetId: ID, $customerId: ID) {
    graphicset(graphicSetId: $graphicSetId, customerId: $customerId) {
      id
      name
      description
      customerId
      hasEvents
      layouts {
        order
        sendTo
        seconds
        assetId
        pos {
          x
          y
        }
        size {
          x
          y
        }
        segments {
          type
          start
          end
        }
        asset {
          id
          codename
          path
          customerId
          format
          categories {
            name
          }
          sizePx {
            x
            y
          }
        }
      }
      schedules {
        type
        period
      }
    }
  }
`;

const getQuery = withAssets => (graphicSetId, customerId) => ({
  query: withAssets ? gqlQueryWithAssets : gqlQuery,
  skip: !graphicSetId || !customerId,
  variables: { graphicSetId, customerId },
});

export default (graphicSetId, customerId) => getQuery(false)(graphicSetId, customerId);
export const getGraphicSetQueryWithAssets = (graphicSetId, customerId) => getQuery(true)(graphicSetId, customerId);
